document.addEventListener("DOMContentLoaded", function () {
  const statisticsBlocks = document.querySelectorAll(".stat");
  const duration = 4000;
  var easing = function (t) {
    return 1 - Math.pow(1 - t, 2 + 4 * t);
  }; 

  function startAnimation(counter) {
    const target = +counter.dataset.target;
    const decimalPlaces =
      target % 1 === 0 ? 0 : target.toString().split(".")[1].length || 0;
    let count = 0; // Start counting from 0
    let startTime = null;
    let animated = false;
  
    function animate(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      const percentage = Math.min(progress / duration, 1);
      const easedProgress = easing(percentage);
      count = target * easedProgress; // Calculate the current count
      count = Number(count.toFixed(decimalPlaces));
      counter.textContent = count.toFixed(decimalPlaces);
      if (progress < duration) {
        requestAnimationFrame(animate);
      } else {
        counter.textContent = target.toFixed(decimalPlaces);
        animated = true;
      }
    }
    
    if (!animated) {
      requestAnimationFrame(animate);
    }
  }
  

  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <=
        (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  function checkCounters() {
    statisticsBlocks.forEach((block) => {
      const counters = block.querySelectorAll(".stat-number");
      counters.forEach((counter) => {
        if (!counter.classList.contains("animated") && isInViewport(counter)) {
          startAnimation(counter);
          counter.classList.add("animated"); 
        }
      });
    });
  }

  window.addEventListener("scroll", checkCounters);
});
